import { gql } from '@apollo/client'

export default gql(`
    mutation deleteAspectRatios($id: [ID]!) {
        deleteAspectRatios(
            input: $id
        )
    }`
)
